import ActionButton from './ActionButton';

export default function ContinueButton({ ...rest }) {
  return (
    <ActionButton className="justify-self-end mt-6" {...rest}>
      Continue
    </ActionButton>
  );
}
